import Vue from 'vue';

export enum STATE {
  LOADED,
  ERROR,
  LOADING
}

/**
 * The state string level
 */
export type StateString = 'loaded' | 'error' | 'loading';

const stateStringToEnum: { [key in StateString]: STATE } = {
  loaded: STATE.LOADED,
  error: STATE.ERROR,
  loading: STATE.LOADING
};

export default Vue.extend({
  name: 'bloc-state',

  data: () => ({
    state: STATE.LOADED,
    STATE,
    error: 'There was an unknown error while processing the request. Try again.'
  }),

  computed: {
    isStateLoaded() {
      return this.state === STATE.LOADED;
    },

    isStateLoading() {
      return this.state === STATE.LOADING;
    },

    isStateError() {
      return this.state === STATE.ERROR;
    }
  },

  methods: {
    setComponentState(
      state: STATE | StateString,
      error?: string | Error | any
    ): void {
      this.state = typeof state === 'string' ? stateStringToEnum[state] : state;
      this.error = error;
    }
  }
});
